import React from 'react';

interface TikTokLogoProps {
  width: string | number;
  height: string | number;
}

const TikTokLogo: React.FC<TikTokLogoProps> = ({ width, height }) => (
  <svg
    width={width || 'auto'}
    height={height || 'auto'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.459 6.84582V10.5048C22.2623 10.5048 22.0262 10.5442 21.7902 10.5442C20.0197 10.5442 18.3672 9.87532 17.1082 8.81303V16.6032C17.1082 18.177 16.5967 19.672 15.6918 20.8524C14.4328 22.5442 12.3869 23.6852 10.0656 23.6852C7.54755 23.6852 5.34428 22.3475 4.1246 20.3802C5.38362 21.5606 7.07542 22.3081 8.9246 22.3081C11.2066 22.3081 13.2525 21.2065 14.5115 19.4753C15.3771 18.295 15.9279 16.8393 15.9279 15.2261V7.39664C17.1869 8.49828 18.8 9.12778 20.6098 9.12778C20.8459 9.12778 21.0426 9.12778 21.2787 9.08844V6.72778C21.6328 6.80647 21.9476 6.84582 22.3017 6.84582H22.459Z"
      fill="#FF004F"
    />
    <path
      d="M11.0492 9.56058V13.613C10.7738 13.5344 10.459 13.495 10.1836 13.495C8.45246 13.495 7.03606 14.9507 7.03606 16.7212C7.03606 17.1147 7.11475 17.4688 7.23279 17.8229C6.4459 17.2327 5.89508 16.2885 5.89508 15.2262C5.89508 13.4557 7.31147 11.9999 9.04262 11.9999C9.35738 11.9999 9.63279 12.0393 9.9082 12.118V9.52124C9.98688 9.52124 10.0656 9.52124 10.1443 9.52124C10.459 9.52124 10.7738 9.52124 11.0492 9.56058Z"
      fill="#FF004F"
    />
    <path
      d="M17.6984 3.93442C16.9902 3.30492 16.4787 2.43934 16.2033 1.53442H17.1475C17.1475 1.73115 17.1475 1.88852 17.1475 2.08524C17.2262 2.71475 17.4229 3.34426 17.6984 3.93442Z"
      fill="#FF004F"
    />
    <path
      d="M21.318 6.76721V9.12787C21.1213 9.16721 20.8853 9.16721 20.6492 9.16721C18.8787 9.16721 17.2262 8.49836 15.9672 7.43606V15.2262C15.9672 16.8 15.4558 18.2951 14.5508 19.4754C13.2525 21.2066 11.2459 22.3082 8.96395 22.3082C7.11477 22.3082 5.42297 21.5607 4.16395 20.3803C3.4951 19.2787 3.10165 18.0197 3.10165 16.6426C3.10165 12.8262 6.13116 9.71803 9.90821 9.6V12.1967C9.6328 12.118 9.31805 12.0787 9.04264 12.0787C7.31149 12.0787 5.8951 13.5344 5.8951 15.3049C5.8951 16.3672 6.40657 17.3508 7.2328 17.9016C7.66559 19.1213 8.84592 20.0262 10.1836 20.0262C11.9148 20.0262 13.3312 18.5705 13.3312 16.8V1.53442H16.2033C16.4787 2.47869 16.9902 3.30492 17.6984 3.93442C18.4066 5.35082 19.7443 6.41311 21.318 6.76721Z"
      fill="#000000"
    />
    <path
      d="M9.9082 8.18367V9.52137C6.13115 9.63941 3.10164 12.7476 3.10164 16.564C3.10164 17.941 3.49508 19.2001 4.16393 20.3017C2.82623 19.0033 2 17.1935 2 15.1476C2 11.2525 5.14754 8.10498 9.00328 8.10498C9.31803 8.10498 9.63279 8.14432 9.9082 8.18367Z"
      fill="#00F7EF"
    />
    <path
      d="M16.2033 1.53443H13.3311V16.7213C13.3311 18.4918 11.9148 19.9475 10.1836 19.9475C8.80656 19.9475 7.66557 19.082 7.23279 17.823C7.74426 18.177 8.37377 18.4131 9.04262 18.4131C10.7738 18.4131 12.1902 16.9967 12.1902 15.2262V0H16.0066V0.0786885C16.0066 0.236066 16.0066 0.393443 16.0459 0.55082C16.0459 0.865574 16.1246 1.21967 16.2033 1.53443Z"
      fill="#00F7EF"
    />
    <path
      d="M21.318 5.31138V6.72777C19.7443 6.41301 18.4066 5.35072 17.659 3.93433C18.6426 4.83924 19.9016 5.35072 21.318 5.31138Z"
      fill="#00F7EF"
    />
  </svg>
);
export default TikTokLogo;
